export default "/_next/static/images/01dfe3c9d7bb35cb1d1c7012c09164d9.png";